export default {
  isPaas: true,
  disableSatismetter: false,
  disableUsetiful: false,
  marketingActivated: false,
  doNotDisplayLogoNColorsSettings: false,
};
